import { render } from "./DockView.vue?vue&type=template&id=05f30877&ts=true"
import script from "./DockView.vue?vue&type=script&lang=ts"
export * from "./DockView.vue?vue&type=script&lang=ts"

import "./DockView.vue?vue&type=style&index=0&id=05f30877&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__